export default class ErrorsHelper {
  static getValidationMessage($vField) {
    if (!$vField.$error) {
      return null;
    }

    if ($vField.$params.requiredIf && !$vField.requiredIf) {
      return 'Required';
    }
    if ($vField.$params.required && !$vField.required) {
      return 'Required';
    }
    if ($vField.$params.required && 'checked' in $vField.$params && !$vField.invalid) {
      return 'Required';
    }
    if ($vField.$params.email && !$vField.email) {
      return 'Invalid email';
    }
    if ($vField.$params.integer && !$vField.integer) {
      return 'Must be an integer';
    }
    if ($vField.$params.minLength && !$vField.minLength) {
      return `Minimum ${ $vField.$params.minLength.min } characters`;
    }
    if ($vField.$params.minValue && !$vField.minValue) {
      return `Minimum value is ${ $vField.$params.minValue.min }`;
    }
    if ($vField.$params.minWords && !$vField.minWords) {
      return `Minimum ${ $vField.$params.minWords.min } words`;
    }
    if ($vField.$params.maxLength && !$vField.maxLength) {
      return `Maximum ${ $vField.$params.maxLength.max } characters`;
    }
    if ($vField.$params.maxValue && !$vField.maxValue) {
      return `Maximum value is ${ $vField.$params.maxValue.max }`;
    }
    if ($vField.$params.maxWords && !$vField.maxWords) {
      return `Maximum ${ $vField.$params.maxWords.max } words`;
    }
    if ($vField.$params.noSpaces && !$vField.noSpaces) {
      return 'No spaces allowed';
    }
    if ($vField.$params.instagramHandle && !$vField.instagramHandle) {
      return 'Invalid Instagram handle';
    }
    if ($vField.$params.twitterHandle && !$vField.twitterHandle) {
      return 'Invalid Twitter handle';
    }
    if ($vField.$params.url && !$vField.url) {
      return 'Invalid URL';
    }
    if ($vField.$params.repeat && !$vField.repeat) {
      return 'Does not match';
    }

    return 'Incorrect field';
  }
}
